/** Read-only reference catalog path (web, Admin seed script, and iOS). */
export const MEDICATION_CATALOG_COLLECTION = 'medicationCatalog';
/** Document id — change only if the `entries` schema is incompatible. */
export const MEDICATION_CATALOG_DOC_ID = 'v1';
